module.exports = __webpack_public_path__ + "static/media/loader.534b1a10.gif";